module.exports = __webpack_public_path__ + "img/xks1.a12dee96.png";